module.exports = __webpack_public_path__ + "img/01.958c20be.jpg";